(function () {
  'use strict';

  const banner = document.querySelector('[data-ae-cookie-banner]');
  if (!banner) return;

  const STORAGE_KEY = 'ae_cookie_consent_v1';
  const STORAGE_VERSION = 1;
  const showDelayMs = parseInt(banner.dataset.showDelay, 10) || 0;
  const expiryDays = parseInt(banner.dataset.expiryDays, 10) || 180;

  const viewInitial = banner.querySelector('[data-ae-cb-view="initial"]');
  const viewManage = banner.querySelector('[data-ae-cb-view="manage"]');
  const inputAnalytics = banner.querySelector('[data-ae-cb-input="analytics"]');
  const inputMarketing = banner.querySelector('[data-ae-cb-input="marketing"]');
  const inputPreferences = banner.querySelector('[data-ae-cb-input="preferences"]');

  function getState() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (data.v !== STORAGE_VERSION) return null;
      if (data.expiresAt && Date.now() > data.expiresAt) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function setState(consent) {
    try {
      const expiresAt = Date.now() + expiryDays * 24 * 60 * 60 * 1000;
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        v: STORAGE_VERSION,
        savedAt: Date.now(),
        expiresAt: expiresAt,
        consent: consent
      }));
    } catch (e) {}
  }

  function applyConsent(consent) {
    function push(api) {
      if (!api || typeof api.setTrackingConsent !== 'function') return;
      try {
        api.setTrackingConsent({
          analytics: !!consent.analytics,
          marketing: !!consent.marketing,
          preferences: !!consent.preferences,
          sale_of_data: !!consent.marketing
        }, function () {});
      } catch (err) {}
    }

    if (window.Shopify && window.Shopify.customerPrivacy) {
      push(window.Shopify.customerPrivacy);
      return;
    }

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          if (!err && window.Shopify.customerPrivacy) push(window.Shopify.customerPrivacy);
        });
      } catch (e) {}
    }

    let attempts = 0;
    const poll = setInterval(function () {
      attempts++;
      if (window.Shopify && window.Shopify.customerPrivacy) {
        clearInterval(poll);
        push(window.Shopify.customerPrivacy);
      } else if (attempts > 40) {
        clearInterval(poll);
      }
    }, 100);

    document.dispatchEvent(new CustomEvent('ae:cookie-consent', { detail: consent }));
  }

  function showView(name) {
    banner.querySelectorAll('[data-ae-cb-view]').forEach(function (v) {
      v.classList.toggle('is-active', v.dataset.aeCbView === name);
    });
  }

  function open() {
    // If the external stylesheet was blocked (cookie filter lists target its
    // filename), showing would render unstyled plain text. The stylesheet sets
    // z-index; the inline fallback does not, so 'auto' means CSS is missing.
    if (getComputedStyle(banner).zIndex === 'auto') return;
    const state = getState();
    if (state && state.consent) {
      if (inputAnalytics) inputAnalytics.checked = !!state.consent.analytics;
      if (inputMarketing) inputMarketing.checked = !!state.consent.marketing;
      if (inputPreferences) inputPreferences.checked = !!state.consent.preferences;
    }
    showView('initial');
    banner.classList.add('is-visible');
    banner.setAttribute('aria-hidden', 'false');
  }

  function close() {
    banner.classList.remove('is-visible');
    banner.setAttribute('aria-hidden', 'true');
  }

  function commit(consent) {
    setState(consent);
    applyConsent(consent);
    close();
  }

  banner.querySelectorAll('[data-ae-cb-accept]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const consent = { essential: true, analytics: true, marketing: true, preferences: true };
      commit(consent);
    });
  });

  banner.querySelectorAll('[data-ae-cb-reject]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const consent = { essential: true, analytics: false, marketing: false, preferences: false };
      commit(consent);
    });
  });

  banner.querySelectorAll('[data-ae-cb-essential]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const consent = { essential: true, analytics: false, marketing: false, preferences: false };
      commit(consent);
    });
  });

  banner.querySelectorAll('[data-ae-cb-manage]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      showView('manage');
    });
  });

  banner.querySelectorAll('[data-ae-cb-back]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      showView('initial');
    });
  });

  banner.querySelectorAll('[data-ae-cb-save]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const consent = {
        essential: true,
        analytics: inputAnalytics ? !!inputAnalytics.checked : false,
        marketing: inputMarketing ? !!inputMarketing.checked : false,
        preferences: inputPreferences ? !!inputPreferences.checked : false
      };
      commit(consent);
    });
  });

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-ae-cookie-open]');
    if (!trigger) return;
    e.preventDefault();
    open();
  });

  const existing = getState();
  if (existing && existing.consent) {
    applyConsent(existing.consent);
  } else {
    if (showDelayMs > 0) {
      setTimeout(open, showDelayMs);
    } else {
      requestAnimationFrame(open);
    }
  }

  window.aeCookieOpen = open;
  window.aeCookieReset = function () {
    localStorage.removeItem(STORAGE_KEY);
  };
})();
